import styles from "../../styles/results.module.css";
import Image from "../common/Image";
import ErrorIcon from "@mui/icons-material/Error";
import commonStyles from "../../styles/common.module.css";
import { useTranslation } from "react-i18next";
const PersonalInformation = ({
  portrait,
  givenName,
  surname,
  issuingCountry
}: {
  portrait:string
  givenName?: string;
  surname?: string;
  issuingCountry?:string
}) => {
  const {t} = useTranslation()
  return (
    <div className={styles.infoPersonalContainer}>
      <>
        <div className={styles.infoPersonalContainerBody}>
          <div className={styles.profileCard}>
            {portrait && <Image
              src={`data:image/jpeg;base64,${portrait}`}
              className={styles.profileCardImg}
            ></Image>}
            {givenName || surname || issuingCountry ? (
              <div className={styles.profileCardDetails}>
                <span className={styles.typography_primary}>
                  {givenName && (
                    <>
                      {givenName} {", "}{" "}
                    </>
                  )}
                  {surname && <>{surname}</>}
                </span>
                {
                  <p className={styles.typography_secondary}>
                    {issuingCountry}
                  </p>
                }
              </div>
            ) : (
              <div className={commonStyles.errorBadge}>
                <ErrorIcon
                  sx={{
                    color: "var(--color-warning)",
                  }}
                />
                <div className={commonStyles.errorHeader}>
                  {t("review.personaldetail.unrecognized")}
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    </div>
  );
};

export default PersonalInformation;
